import { ShieldAlert } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function BannedScreen() {
    const { logout } = useAuth();
    
    return (
        <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #0a0e1a 0%, #111827 50%, #0a0e1a 100%)',
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            position: 'relative', overflow: 'hidden',
        }}>
            {/* Background glow */}
            <div style={{
                position: 'absolute', top: '30%', left: '50%', transform: 'translate(-50%, -50%)',
                width: 500, height: 500, borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(239, 68, 68, 0.08) 0%, transparent 70%)',
                pointerEvents: 'none',
            }} />

            {/* Logout Button (top-right) */}
            <button
                onClick={logout}
                style={{
                    position: 'absolute', top: 20, right: 20,
                    display: 'flex', alignItems: 'center', gap: 6,
                    padding: '6px 14px', borderRadius: 6,
                    border: '1px solid rgba(255,255,255,0.08)',
                    background: 'rgba(255,255,255,0.04)',
                    color: '#6b7280', fontSize: 11, fontWeight: 600, cursor: 'pointer',
                }}
            >
                Ausloggen
            </button>

            {/* Main Content */}
            <div style={{ textAlign: 'center', zIndex: 1 }}>
                <div style={{
                    width: 80, height: 80, borderRadius: 20,
                    background: 'rgba(239, 68, 68, 0.1)', border: '1px solid rgba(239, 68, 68, 0.2)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    margin: '0 auto 32px',
                }}>
                    <ShieldAlert size={40} color="#f87171" />
                </div>
                <h1 style={{
                    fontSize: 32, fontWeight: 800, color: '#fff',
                    letterSpacing: '-0.02em', marginBottom: 12,
                }}>
                    Zugang Gesperrt
                </h1>
                <p style={{
                    fontSize: 15, color: '#9ca3af', maxWidth: 420, lineHeight: 1.6,
                }}>
                    Dein Konto wurde von der Administration des StratSync Netzwerks ausgeschlossen. 
                    Ein Zugriff auf die Plattform oder jegliche Team-Assets ist nicht mehr möglich.
                </p>
            </div>
        </div>
    );
}
